import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { SpecialTarifsContent } from './components/SpecialTarifsContent';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';

const SpecialTarifs: PageWithLayout<unknown> = () => {
    return (
        <>
            <Helmet>
                <title>Spezialtarife | Starjack Admin</title>
            </Helmet>

            <SpecialTarifsContent isSpecialTarifsNew={false} />
        </>
    );
};

SpecialTarifs.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
SpecialTarifs.isProtected = true;
SpecialTarifs.permissions = [Permission.EXTERNAL_CODES_NAV];

export default SpecialTarifs;
